import React from "react";
import { Link } from "react-router-dom";
import { SEO } from "./seo";

export const NotFound = () => {
  return (
    <>
      <SEO
        title="Page Not Found | Hamilton Pressure Washing"
        description="The page you were looking for has moved or no longer exists."
        robots="noindex, follow"
      />
      <div id="not-found" className="text-center">
        <div className="container">
          <h1>That page isn't here</h1>
          <p>
            The page you were looking for has moved or no longer exists. We're
            still cleaning homes and businesses across Clinton, NC and Sampson
            County.
          </p>
          <ul className="not-found-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/services">Pressure washing services</Link>
            </li>
            <li>
              <Link to="/service-areas">Areas we serve</Link>
            </li>
            <li>
              <Link to="/contact">Contact us</Link>
            </li>
          </ul>
          <a href="tel:+19109901974" className="btn btn-custom btn-lg">
            Call (910) 990-1974
          </a>
        </div>
      </div>
    </>
  );
};
